// templateUtils.tsx
import { ResumePDF } from "components/Resume/ResumePDF";
import { TemplateTwo } from "./TemplateTwo";
import { TemplateThree } from "./TemplateThree";
import { TemplateFour } from "./TemplateFour";
import { TemplateFive } from "./TemplateFive";
import { TemplateSix } from "./TemplateSix";
import { selectResume } from "lib/redux/resumeSlice";
import { selectTemplate } from "lib/redux/settingsSlice";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { DEBUG_RESUME_PDF_FLAG } from "lib/constants";
import { JSX, useEffect, useMemo } from "react";
import type { Resume } from "lib/redux/types";
import type { Settings, ShowForm } from "lib/redux/settingsSlice";
import TemplateSeven from "./TemplateSeven";
import { TemplateEight } from "./ResumeEight";
import TemplateNine from "./resumeNine";
import TemplateEleven from "./ResumeEleven";
import { TemplateThirteen } from "./ResumeThirteen";

import { ResumeSeventeen } from "./ResumeSeventeen";
import { ResumeTwentyOne } from "./ResumeTwentyOne";
import { ResumeNineteen } from "./ResumeNineteen";
import { TemplateFifteen } from "./ResumeFifteen";
import { TemplateSixteen } from "./ResumeSixteen";
import { ResumeEighteen } from "./ResumeEighteen";
import { TemplateFourteen } from "./ResumeFourteen";
import { TemplateTwelve } from "./ResumeTwelve";
import { TemplateTwenty } from "./TemplateTwenty";
import { selectUserProfilePhoto } from "lib/redux/uiSlice";

export const useTemplateComponents = (resume: Resume, settings: Settings) => {
  const template = useAppSelector(selectTemplate);
  const userProfilePhoto = useAppSelector(selectUserProfilePhoto);
  useEffect(() => {
    console.log("Selected template:", template);
  }, [template]);
  const document1 = useMemo(
    () => <ResumePDF resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document2 = useMemo(
    () => <TemplateTwo resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document3 = useMemo(
    () => <TemplateThree resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document4 = useMemo(
    () => <TemplateFour resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document5 = useMemo(
    () => <TemplateFive resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document6 = useMemo(
    () => <TemplateSix resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document7 = useMemo(
    () => <TemplateSeven resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document8 = useMemo(
    () => <TemplateEight resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document9 = useMemo(
    () => <TemplateNine resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document11 = useMemo(
    () => <TemplateEleven resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document12 = useMemo(
    () => <TemplateTwelve resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document13 = useMemo(
    () => <TemplateThirteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document14 = useMemo(
    () => <TemplateFourteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document15 = useMemo(
    () => <TemplateFifteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document16 = useMemo(
    () => <TemplateSixteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document17 = useMemo(
    () => <ResumeSeventeen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document18 = useMemo(
    () => <ResumeEighteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document19 = useMemo(
    () => <ResumeNineteen resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document21 = useMemo(
    () => <ResumeTwentyOne resume={resume} settings={settings} isPDF={true} />,
    [resume, settings]
  );
  const document20 = useMemo(
    () => (
      <TemplateTwenty
        resume={resume}
        settings={settings}
        isPDF={true}
        userProfilePhoto={userProfilePhoto}
      />
    ),
    [resume, settings]
  );

  const TemplateNameToComponent: { [key: number]: JSX.Element } = {
    1: (
      <ResumePDF
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    2: (
      <TemplateTwo
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    3: (
      <TemplateThree
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    4: (
      <TemplateFour
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    5: (
      <TemplateFive
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    6: (
      <TemplateSix
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    7: (
      <TemplateSeven
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    8: (
      <TemplateEight
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    9: (
      <TemplateNine
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    11: (
      <TemplateEleven
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    12: (
      <TemplateTwelve
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    13: (
      <TemplateThirteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    14: (
      <TemplateFourteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    15: (
      <TemplateFifteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    16: (
      <TemplateSixteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    17: (
      <ResumeSeventeen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    18: (
      <ResumeEighteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    19: (
      <ResumeNineteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    21: (
      <ResumeTwentyOne
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
      />
    ),
    20: (
      <TemplateTwenty
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        userProfilePhoto={userProfilePhoto}
      />
    ),
  };
  const TemplateNameToHighlightResume: { [key: number]: JSX.Element } = {
    1: (
      <ResumePDF
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    2: (
      <TemplateTwo
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    3: (
      <TemplateThree
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    4: (
      <TemplateFour
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    5: (
      <TemplateFive
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    6: (
      <TemplateSix
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    7: (
      <TemplateSeven
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    8: (
      <TemplateEight
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    9: (
      <TemplateNine
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    11: (
      <TemplateEleven
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    12: (
      <TemplateTwelve
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    13: (
      <TemplateThirteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    14: (
      <TemplateFourteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    15: (
      <TemplateFifteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    16: (
      <TemplateSixteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    17: (
      <ResumeSeventeen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    18: (
      <ResumeEighteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    19: (
      <ResumeNineteen
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    21: (
      <ResumeTwentyOne
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
    20: (
      <TemplateTwenty
        resume={resume}
        settings={settings}
        isPDF={DEBUG_RESUME_PDF_FLAG}
        userProfilePhoto={userProfilePhoto}
        enableHighlight={true}
        enableMistakeHighlight={true}
      />
    ),
  };

  const templateNameToDocument: { [key: number]: JSX.Element } = {
    1: document1,
    2: document2,
    3: document3,
    4: document4,
    5: document5,
    6: document6,
    7: document7,
    8: document8,
    9: document9,
    11: document11,
    12: document12,
    13: document13,
    14: document14,
    15: document15,
    16: document16,
    17: document17,
    18: document18,
    19: document19,
    21: document21,
    20: document20,
  };

  const templateNameToResumeComponent = (
    resume: Resume,
    settings: Settings,
    templateId: number
  ): JSX.Element | null => {
    switch (templateId) {
      case 1:
        return (
          <ResumePDF
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );
      case 2:
        return (
          <TemplateTwo
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );
      case 3:
        return (
          <TemplateThree
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );
      case 4:
        return (
          <TemplateFour
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );

      case 6:
        return (
          <TemplateSix
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );
      case 7:
        return (
          <TemplateSeven
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
          />
        );
      case 8:
        <TemplateEight
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 9:
        <TemplateNine
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 11:
        <TemplateEleven
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 12:
        <TemplateTwelve
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 13:
        <TemplateThirteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 14:
        <TemplateFourteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 15:
        <TemplateFifteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 16:
        <TemplateSixteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 17:
        <ResumeSeventeen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 18:
        <ResumeEighteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 19:
        <ResumeNineteen
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 21:
        <ResumeTwentyOne
          resume={resume}
          settings={settings}
          isPDF={DEBUG_RESUME_PDF_FLAG}
        />;
      case 20:
        return (
          <TemplateTwenty
            resume={resume}
            settings={settings}
            isPDF={DEBUG_RESUME_PDF_FLAG}
            userProfilePhoto={userProfilePhoto}
          />
        );
      default:
        return null;
    }
  };

  interface Template {
    id: number;
    name: string;
    imageUrl: string;
    columns: "single" | "double";
    fontSize: string;
    fontFamily: string;
    themeColor: string;
    formsOrder?: {
      left: ShowForm[];
      right: ShowForm[];
    };
    hasImage: boolean;
    order: number;
  }

  const templateList: Template[] = [
    {
      id: 1,
      name: "Template 1",
      imageUrl: "/assets/templateImages/template1-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 1,
    },
    {
      id: 2,
      name: "Template 2",
      imageUrl: "/assets/templateImages/template2-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 4,
    },
    {
      id: 3,
      name: "Template 3",
      imageUrl: "/assets/templateImages/template3-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 5,
    },
    {
      id: 4,
      name: "Template 4",
      imageUrl: "/assets/templateImages/template4-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 7,
    },
    {
      id: 5,
      name: "Template 5",
      imageUrl: "/assets/templateImages/template5-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 3,
    },
    {
      id: 6,
      name: "Template 6",
      imageUrl: "/assets/templateImages/template6-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#000000",
      hasImage: false,
      order: 2,
    },
    {
      id: 7,
      name: "Template 7",
      imageUrl: "/assets/templateImages/template7-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: false,
      order: 10,
    },
    {
      id: 8,
      name: "Template 8",
      imageUrl: "/assets/templateImages/template8-preview.webp",
      columns: "double",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#6565e7",
      formsOrder: {
        left: ["educations", "languages"],
        right: [
          "workExperiences",
          "projects",
          "skills",
          "certifications",
          "awards",
          "custom",
        ],
      },
      hasImage: false,
      order: 13,
    },
    {
      id: 9,
      name: "Template 9",
      imageUrl: "/assets/templateImages/template9-preview.webp",
      columns: "single",
      fontSize: "8",
      fontFamily: "PlayfairDisplay",
      themeColor: "#ef4444",
      hasImage: false,
      order: 8,
    },
    {
      id: 11,
      name: "Template 11",
      imageUrl: "/assets/templateImages/template11-preview.webp",
      columns: "single",
      fontSize: "10",
      fontFamily: "Lora",
      themeColor: "#ef4444",
      hasImage: false,
      order: 6,
    },
    {
      id: 12,
      name: "Template 12",
      imageUrl: "/assets/templateImages/template12-preview.webp",
      columns: "double",
      fontSize: "11",
      fontFamily: "PlayfairDisplay",
      themeColor: "#0d2867",
      hasImage: false,
      formsOrder: {
        left: ["educations", "languages"],
        right: [
          "workExperiences",
          "projects",
          "skills",
          "certifications",
          "awards",
          "custom",
        ],
      },
      order: 18,
    },
    {
      id: 13,
      name: "Template 13",
      imageUrl: "/assets/templateImages/template13-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#15803d",
      formsOrder: {
        left: ["educations", "languages", "custom"],
        right: [
          "workExperiences",
          "projects",
          "skills",
          "certifications",
          "awards",
        ],
      },
      hasImage: false,
      order: 17,
    },
    {
      id: 14,
      name: "Template 14",
      imageUrl: "/assets/templateImages/template14-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#15803d",
      formsOrder: {
        left: ["certifications", "languages", "custom"],
        right: [
          "workExperiences",
          "educations",
          "projects",
          "skills",

          "awards",
        ],
      },
      hasImage: false,
      order: 9,
    },
    {
      id: 15,
      name: "Template 15",
      imageUrl: "/assets/templateImages/template15-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#0ea5e9",
      formsOrder: {
        left: ["workExperiences", "educations", "skills", "languages"],
        right: ["projects", "certifications", "awards", "custom"],
      },
      hasImage: false,
      order: 19,
    },
    {
      id: 16,
      name: "Template 16",
      imageUrl: "/assets/templateImages/template16-preview.webp",
      columns: "double",
      fontSize: "10",
      fontFamily: "PlayfairDisplay",
      themeColor: "#15803d",
      formsOrder: {
        left: ["workExperiences", "projects", "custom"],
        right: [
          "skills",
          "educations",
          "languages",
          "certifications",
          "awards",
        ],
      },
      hasImage: false,
      order: 12,
    },
    {
      id: 17,
      name: "Template 17",
      imageUrl: "/assets/templateImages/template17-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#0ea5e9",
      formsOrder: {
        left: ["workExperiences", "projects", "educations", "languages"],
        right: ["skills", "certifications", "awards", "custom"],
      },
      hasImage: false,
      order: 14,
    },
    {
      id: 18,
      name: "Template 18",
      imageUrl: "/assets/templateImages/template18-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#0ea5e9",
      formsOrder: {
        left: [],
        right: [
          "skills",
          "workExperiences",
          "projects",
          "educations",
          "languages",
          "certifications",
          "awards",
          "custom",
        ],
      },
      hasImage: false,
      order: 16,
    },
    {
      id: 19,
      name: "Template 19",
      imageUrl: "/assets/templateImages/template19-preview.webp",
      columns: "double",
      fontSize: "10",
      fontFamily: "Montserrat",
      themeColor: "#000000",
      formsOrder: {
        left: ["skills", "educations", "languages", "custom"],
        right: ["workExperiences", "projects", "certifications", "awards"],
      },
      hasImage: false,
      order: 15,
    },
    {
      id: 21,
      name: "Template 21",
      imageUrl: "/assets/templateImages/template21-preview.webp",
      columns: "double",
      fontSize: "9",
      fontFamily: "Montserrat",
      themeColor: "#f97316",
      formsOrder: {
        left: ["projects", "workExperiences", "educations"],
        right: ["skills", "languages", "certifications", "awards", "custom"],
      },
      hasImage: false,
      order: 11,
    },
    {
      id: 20,
      name: "Template 20",
      imageUrl: "/assets/templateImages/template20-preview.webp",
      columns: "single",
      fontSize: "11",
      fontFamily: "Roboto",
      themeColor: "#38bdf8",
      hasImage: true,
    order: 20,
    },
  ];

  const filterTemplatesByColumns = (
    templates: Template[],
    columns: "single" | "double"
  ): Template[] => {
    return templates.filter((template) => template.columns === columns);
  };

  return {
    TemplateNameToComponent,
    templateNameToDocument,
    templateNameToResumeComponent,
    TemplateNameToHighlightResume,
    template,
    templateList,
    filterTemplatesByColumns,
  };
};
